export const emptyContactFormData = {
  firstName: '',
  lastName: '',
  email: '',
  message: '',
  phoneNumber: '',
  location: '',
  businessName: '',
};
